module.exports = __webpack_public_path__ + "static/media/close-icon-black.b2aaa74b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/close-icon-black.svg
// module id = 847
// module chunks = 21